export default "__VITE_ASSET__Bqz7sq7r__"